<template functional>
  <div class="multiselect-selected-item">
    <slot />
    <button @click="listeners['click:remove'] ? listeners['click:remove']() : null">
      <i class="budicon-cross-ui"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'MultiSelectSelectedItem',
};
</script>

<style scoped lang="scss">
.multiselect-selected-item {
  display: flex;
  user-select: none;
  align-items: center;

  button {
    appearance: none;
    background-color: #fff;
    border: 1px solid var(--gray);
    color: var(--gray);
    border-radius: 50%;
    width: 18px;
    height: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 0.2rem;

    &:hover {
      border-color: var(--gray-dark);
      color: var(--gray-dark);
    }
  }
}
</style>
